const previews = document.querySelectorAll('.team-member-preview');

function closePanel(preview, full) {
    const grid = document.querySelector('.meet_the_team .team-grid');
    const text = document.querySelector('.meet_the_team .text-container');
    preview.classList.remove('active');
    full.classList.remove('active');
    full.style.height = '0';
    grid.style.height = grid.scrollHeight + 'px';
    text.style.height = text.scrollHeight + 'px';
    full.addEventListener('transitionend', () => {
        if (typeof AOS !== 'undefined') AOS.refresh();
    }, { once: true });
}

previews.forEach((preview) => {
    preview.addEventListener('click', function () {
        const value = preview.dataset.memberValue;
        const full = document.querySelector(`.team-member-full[data-member-target="${value}"]`);
        const grid = document.querySelector('.meet_the_team .team-grid');
        const text = document.querySelector('.meet_the_team .text-container');

        if (!full) return;

        // Close any other open panels
        previews.forEach((p) => {
            if (p.classList.contains('active') && p !== preview) {
                p.classList.remove('active');
                const otherFull = document.querySelector(`.team-member-full[data-member-target="${p.dataset.memberValue}"]`);
                if (otherFull) { otherFull.classList.remove('active'); otherFull.style.height = '0'; }
            }
        });

        grid.style.height = grid.scrollHeight + 'px';
        text.style.height = text.scrollHeight + 'px';

        preview.classList.add('active');
        full.classList.add('active');
        full.style.height = full.scrollHeight + 'px';
        grid.style.height = '0';
        text.style.height = '0';

        full.addEventListener('transitionend', () => {
            //const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const top = full.getBoundingClientRect().top + window.scrollY - 150;
            window.scrollTo({ top, behavior: 'smooth' });
            if (typeof AOS !== 'undefined') AOS.refresh();
        }, { once: true });
    });
});

document.querySelectorAll('.team-member-full .close-button').forEach((btn) => {
    btn.addEventListener('click', function () {
        const full = btn.closest('.team-member-full');
        const target = full.dataset.memberTarget;
        const preview = document.querySelector(`.team-member-preview[data-member-value="${target}"]`);
        if (preview) closePanel(preview, full);
    });
});
